import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export default function FinancialPopup({ message, showCondition, buttonLabel = "Sprawozdania Finansowe", storageKey = "financialPopupShown", onClose }) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    // 🔑 pokazuj tylko raz po zalogowaniu (jeśli podano storageKey)
    useEffect(() => {
        if (!storageKey) {
            setOpen(showCondition);
            return;
        }
        if (!showCondition) {
            setOpen(false);
            return;
        }
        const alreadyShown = sessionStorage.getItem(storageKey);
        if (showCondition && !alreadyShown) {
            setOpen(true);
            sessionStorage.setItem(storageKey, "true");
        }
    }, [showCondition, storageKey]);

    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: 6,
                },
            }}
        >
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                Powiadomienie
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Typography style={{ whiteSpace: 'pre-line' }}>{message}</Typography>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => {
                        handleClose();
                        navigate("/FinancialStatements");
                    }}
                    variant="contained"
                    color="primary"
                >
                    {buttonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
